import React, { useState } from 'react';
import { Body, SectionHeader } from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import { withLocalePrefix } from '../shared/utils/translation';
import AuthorizeAction from './authorize_action';
import ConsentAction from './consent_action';
import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import { LogoContainer } from './styled_components';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  name: string;
  scopes: string[];
  accountSettingsUrl: string;
  companyLogoUrl: string;
  denyUrl: string;
  isOidcFlow?: boolean;
  isSiteAdmin?: boolean;
  emailValidation?: {
    email: string;
    error: string;
  };
};

const AUTHORIZE_PATH = '/authorize';
const CONSENT_PATH = '/oauth/consent';

export default function AuthorizationForm({
  name,
  scopes,
  accountSettingsUrl,
  companyLogoUrl,
  denyUrl,
  isOidcFlow,
  isSiteAdmin,
  emailValidation,
}: Props) {
  const pathName = window.location.pathname;
  const [useServiceAccount, setUseServiceAccount] = useState(false);

  const onCancel = () => {
    window.location.href = denyUrl;
  };

  return (
    <>
      <SectionHeader>
        {t('title.authorize')} <strong>{name}</strong>{' '}
        {t('title.to_use_GH_account')}
      </SectionHeader>
      <Grid container>
        <Grid item xs={7}>
          <Stack sx={{ marginTop: 3, marginBottom: 3 }} spacing={0}>
            <Body>{t('scope_description')}</Body>
            <ul>
              {scopes.map((description) => (
                <li key={description}>
                  <Body as={'span'}>{description}</Body>
                </li>
              ))}
            </ul>
          </Stack>
          {pathName === CONSENT_PATH && isSiteAdmin && !isOidcFlow && (
            <Stack spacing={2} sx={{ marginBottom: 3 }}>
              <input
                type={'hidden'}
                name={'authorize_service_account'}
                id={'authorize_service_account'}
                value={useServiceAccount ? 'true' : 'false'}
              />
              <Checkbox
                data-test={'use-service-account-checkbox'}
                checked={useServiceAccount}
                onChange={(checked: boolean) => {
                  setUseServiceAccount(checked);
                }}
                label={t('use_service_account_label')}
                value={'use_service_account'}
                helperText={t('use_service_account_helper')}
              />
            </Stack>
          )}
          {pathName === AUTHORIZE_PATH && (
            <AuthorizeAction
              accountSettingsUrl={accountSettingsUrl}
              error={emailValidation?.error}
              email={emailValidation?.email}
              onCancel={onCancel}
            />
          )}
          {pathName === CONSENT_PATH && (
            <ConsentAction
              accountSettingsUrl={accountSettingsUrl}
              onCancel={onCancel}
            />
          )}
        </Grid>
        {companyLogoUrl && (
          <Grid item xs={5}>
            <LogoContainer>
              <img src={companyLogoUrl} alt={name} />
            </LogoContainer>
          </Grid>
        )}
      </Grid>
    </>
  );
}
